<template>
  <div class="home">
    <div class="row" id="turnstileList">

      <div class="col-md-12">
        <div class="card bg-secondary">
          <div class="card-body">
            <div class="dashboard-info">
              <div class="info-text">
                <div class="row">
                  <div class="col-md-6">
                    <h5 class="card-title">
                      <img src="/assets/images/logo.png" height="30"> Turnstile Manager
                    </h5>
                  </div>
                  <div class="col-md-6 text-sm-right">
                    <div v-if="!$auth.loading">
                      <h6>
                        <span id="userEmail" v-bind:data-venue-id="$auth.user['https://guestx.com/app_metadata'].venueId">
                          {{ $auth.user.email }}
                        </span>
                        (<a href="#" v-if="$auth.isAuthenticated" @click.prevent="logout">Log out</a>)
                      </h6>
                    </div>
                  </div>
                </div>
                <p>Turnstiles will automatically appear below as soon as an activity oocurs.</p>
              </div>
            </div>
          </div>
        </div>
      </div>

    </div>
  </div>
</template>

<script>
export default {
  name: 'home',
  methods: {
    // Log the user in
    login() {
      this.$auth.loginWithRedirect();
    },
    // Log the user out
    logout() {
      this.$auth.logout({
        returnTo: window.location.origin,
      });
    },
  },
};
</script>
